import Cookies from 'js-cookie';

const isConsentCookie = (candidate) =>
    typeof candidate === 'object' &&
    candidate !== null &&
    'categories' in candidate &&
    candidate.categories !== undefined &&
    Array.isArray(candidate.categories);

export const isGoogleAnalyticsEnabled = () => {
    const consentCookie = Cookies.get('cookie_consent');

    if (!consentCookie) {
        return false;
    }

    const parsedCookie = JSON.parse(consentCookie);

    if (!isConsentCookie(parsedCookie)) {
        return false;
    }

    const analyticsCookieCategory = parsedCookie.categories.find(
        (cookieCategory) => cookieCategory.id === 'ANALYTICS'
    );

    if (!analyticsCookieCategory) {
        return false;
    }

    return analyticsCookieCategory.accepted;
};
